<template>
  <div :data-id="panelId" class="flex flex-col pb-16">
    <div
      :data-id="panelId"
      class="sticky top-0 z-10 flex flex-col bg-pure-white"
    >
      <div :data-id="panelId" class="flex flex-col gap-2 px-6 py-6">
        <div :data-id="panelId" class="flex items-center justify-between gap-4">
          <BlTextTitle4 :data-id="panelId" text="Reschedule credits" />
          <BlIcon icon="close" :clickable="true" />
        </div>
      </div>
    </div>

    <div
      :data-id="panelId"
      v-if="!rescheduleCredits.length"
      class="grid px-16 h-128 place-items-center"
    >
      <BlTextBody1
        :data-id="panelId"
        text="All reschedule credits will appear here once you add credits to the client."
        class="text-center"
      />
    </div>

    <div :data-id="panelId" class="flex flex-col px-6">
      <!-- Total reschedule credits -->
      <div
        :data-id="panelId"
        class="flex flex-col gap-1 py-3 border-b border-slate-400"
      >
        <div :data-id="panelId" class="flex items-center justify-between gap-2">
          <BlTextBody2
            :data-id="panelId"
            text="Total reschedule credits"
            class="text-slate-700"
          />
          <BlTextBody2
            :data-id="panelId"
            :text="`${totalRescheduleCredits} credit(s)`"
            class="text-slate-1000"
          />
        </div>
        <div
          :data-id="panelId"
          v-for="credit in rescheduleCredits"
          :key="credit.id"
          class="flex items-center justify-between gap-2 truncate"
        >
          <BlTextBody2
            :data-id="panelId"
            :text="`ID ${credit.id}`"
            class="truncate text-slate-700"
          />
          <div :data-id="panelId">
            <BlTextBody2
              :data-id="panelId"
              v-if="credit.remaining_reschedule_credit === null"
              :text="`∞ credit(s)`"
              class="flex-shrink-0 text-slate-700"
            />
            <BlTextBody2
              :data-id="panelId"
              v-else
              :text="`${credit.remaining_reschedule_credit} credit(s)`"
              class="flex-shrink-0 text-slate-700"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { displayDate, displayPrice } from "@/plugins/helper.js";

import BlTextTitle4 from "../../BlTextTitle4.vue";
import BlTextBody1 from "../../BlTextBody1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "RescheduleCreditsPanel",
  components: {
    BlTextTitle4,
    BlTextBody1,
    BlTextBody2,
    BlIcon
  },
  props: {
    panelId: { type: String }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentCenter", "creditTransactionDetails"]),
    rescheduleCredits() {
      if (!this.creditTransactionDetails) return [];
      return (this.creditTransactionDetails.reschedule_credits || []).filter(
        i => {
          return (
            i.remaining_reschedule_credit === null ||
            i.remaining_reschedule_credit > 0
          );
        }
      );
    },
    totalRescheduleCredits() {
      const arr = this.rescheduleCredits.map(
        i => i.remaining_reschedule_credit
      );
      const sum = arr.reduce((sum, i) => (sum += i || 0), 0);
      if (arr.includes(null)) {
        if (sum > 0) return `∞ + ${sum}`;
        return `∞`;
      }
      return sum;
    }
  },
  mounted() {},
  methods: {
    ...mapActions([""]),
    displayDate,
    displayPrice,
    priceFormats(price = 0) {
      const settings = this.currentCenter.currency_settings;
      return this.displayPrice({ settings, price });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/creditTransaction/RescheduleCreditsPanel.vue